import { keys } from "lodash";
import { stepKeys, steps } from "./steps";
import { MAIN_ID } from "../util/constants";

export function transformRequest(stepState) {
    const input = {};
    keys(stepState).forEach(stepKey => {
        const values = stepState[stepKey].values;
        switch(stepKey) {
            case stepKeys.CONTACT_INFORMATION:
                input.firstName = values.firstName;
                input.lastName = values.lastName;
                input.email = values.email;
                break;
            case stepKeys.REQUEST:
                input.audience = values.audience;
                input.message = values.message;
                input.topic = values.topic;
                input.service = values.service;
                input.subtopic = values.subtopic;
                input.selectionMappingId = values.selectionMappingId;
                input.salesforceRoutingId = values.salesforceRoutingId;
                input.unit = values.unit;
                input.assignmentGroup = values.assignmentGroup;
                input.uServiceProvider = values.uServiceProvider;
                break;
            default:
        }
    });
    return { input };
}

const findStepBy = ({ key, index }) => {
    let callback
    if(key !== undefined) {
        callback = step => key && ((key === step?.key) || ((key || "").toLowerCase() === (step?.key || "").toLowerCase()))
    } else if (index !== undefined) {
        callback = (step) => index === step?.index
    }
    if(!callback) {
        return undefined
    }
    return steps.find(callback);
}

const getStepByHash = (hash = '') => {
    const keyToRender = hash.startsWith("#") ? hash.slice(1) : hash
    const relevantStep = findStepBy({ key: keyToRender })
    return relevantStep
}

export const getStepIndexAndReroute = (hash, stepState) => {
    let redirect = undefined
    const newIndex = getDefaultStepState(hash, stepState)
    let hashForNewIndex = (findStepBy({ index: newIndex })?.key || "").toUpperCase()
    const doNotRedirect = [hashForNewIndex, MAIN_ID].some(item => `#${item}` === hash)
    if(!doNotRedirect) {
        redirect = "#" + hashForNewIndex
    }

    return {
        redirect,
        index: newIndex
    }
}

export const getDefaultStepState = (hash = "", stepState) => {
    if(!hash) return -1
    const relevantStep = getStepByHash(hash)
    if(hash === ("#" + MAIN_ID)) {
        let newIndex = -1
        for (const step of steps) {
            newIndex = step.index
            if (!stepState?.[step.key]?.isComplete) {
                break;
            }
        }

        return newIndex
    }
    let stepToRender
    if(stepState[relevantStep?.key]) {
        const stepsPrior = steps.filter(({ index: stepIndex}) => {
            return stepIndex < relevantStep.index
        })
        const reversedSteps = [...stepsPrior].reverse()
        const lastCompletedStep = reversedSteps.find(item => {
            return stepState[item?.key].isComplete
        }) ?? {}
        if(lastCompletedStep?.index !== undefined) {
            stepToRender = (relevantStep.index <= (lastCompletedStep.index + 1))
                ? relevantStep.index
                : lastCompletedStep.index + 1
        } else if (relevantStep.index === 0) {
            if(stepState[relevantStep?.key]?.isComplete) {
                return relevantStep.index
            } else if(stepsPrior?.length === 1 && (stepKeys.LOGIN === stepsPrior[0].key) && !stepState[stepKeys.LOGIN]?.isComplete) {
                return stepsPrior[0].index
            }
            return 0
        } else {
            const allStepsBeforeCurrent = steps.filter(step => step.index < relevantStep.index)
            const atLeastOneStepNotFinished = allStepsBeforeCurrent.some(priorStep => !stepState?.[priorStep?.key]?.isComplete)
            if(atLeastOneStepNotFinished) {
                stepToRender = -1
                return stepToRender
            }
        }
    }

    if(Number.isNaN(stepToRender) || stepToRender === undefined) stepToRender = -1
    return stepToRender
}
